<template lang="pug">
.register-row
  .register-group
    .register-key
      span.key-name(v-if="keyName" :class="{ 'non-active-font': !active }") {{ keyName }}
      slot(name="keyName")
      span.validation-label(v-if="required == true") 必須
      span.option-text.font-strong-color {{ optionText }}
      slot(name="question")

    .register-value
      input.register-form(
        v-model="_value"
        :name="name"
        :type="type"
        :placeholder="placeholder"
        v-validate="validationRules"
        :maxlength="maxlength"
        :max="max"
        :min="min"
        :data-vv-as="(validationKeyName) ? validationKeyName : keyName"
        :style="styles"
        :class="[ { noinput: (required == true && !_value) }, { 'non-active': !active } ]"
        :disabled="!active"
        @change="onChange")
      span(v-if="unitText") {{ unitText }}

    .error-messages(v-for="error in errors.collect(name)")
      label.error-message {{ error }}
      br

    slot(name="default")

</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

const INPUT_TYPES = ["text", "password", "email", "number", "url", "tel", "search", "range", "color", "date", "time", "datetime", "datetime-local", "month", "week"];

/**
 * 入力要素コンポーネント
 *
 * - 単一の入力をサポートする
 * - 既存の入力画面のスタイルが適用される
 * - バリデーターは親コンポーネントのものをInjectionして使用する
 *   - そのため、親コンポーネントでveevalidateをnewしておく必要がある
 */
@Component
export default class FormInput extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ required: true })
  value!: string;

  /** 項目名 */
  @Prop({ type: String })
  keyName!: string;

  /** 必須か */
  @Prop({
    default: () => {
      return false;
    },
    type: Boolean
  })
  required!: boolean;

  /** name属性の値 */
  @Prop({ required: true, type: String })
  name!: string;

  /** inputType */
  @Prop({
    required: true,
    type: String,
    validator: (type) => {
      return INPUT_TYPES.indexOf(type) !== -1;
    }
  })
  type!: string;

  /** input要素のプレースホルダー */
  @Prop({
    default: () => {
      return "";
    },
    type: String
  })
  placeholder!: string;

  /** 最大長 */
  @Prop({ type: Number })
  maxlength!: number;

  /** 最大値 */
  @Prop({ type: Number })
  max!: number;

  /** 最小値 */
  @Prop({ type: Number })
  min!: number;

  /** 単位 */
  @Prop({ type: String })
  unitText!: string;

  /** veevalidateに渡すバリデーションルール */
  @Prop()
  validationRules!: string;

  /** veevalidateに渡すバリデーション項目名 */
  @Prop({
    default: () => {
      return "";
    },
    type: String
  })
  validationKeyName!: string;

  /** スタイル(主にサイズ指定) */
  @Prop({
    default: () => {
      return {};
    },
    type: Object
  })
  styles!: any;

  /** 説明文 */
  @Prop({
    default: () => {
      return "";
    },
    type: String
  })
  optionText!: string;

  /** 活性化/非活性化 */
  @Prop({
    default: () => {
      return true;
    }
  })
  active!: boolean;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): string {
    return this.value;
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: string) {
    this.$emit("input", newValue);
    return;
  }

  public onChange(): void {
    this.$emit("change");
    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

.register-form {
  max-width: 600px;
  width: 600px;
}
.option-text {
  margin-left: 8px;
}
.non-active-font {
  color: $form-border-color;
}
.non-active {
  cursor: not-allowed;
  color: $form-border-color;
  background-color: $bg-gray !important;
}
</style>
